import { Enum } from 'enumify';

export class CcProductAttribute extends Enum {
	get label (): string {
		return 'enum_product_attribute_'.concat(this.name.concat('_label'));
	}
}

CcProductAttribute.initEnum([
	'BIOLOGICAL',
	'GLUTEN_FREE',
	'LACTOSE_FREE',
	'YEAST_FREE',
	'PALM_OIL_FREE',
	'SUGAR_FREE',
	'HUNDRED_PERCENT_ITALIAN',
	'VEGETABLE',
	'WHOLEMEAL',
	'SALT_FREE'
]);

export interface CcProductattributeOption {
	label: string;
	code: string;
}
